import {
  BackendServerActionType,
  ButtonElementModel,
  DevelopDialogScript,
  DevelopScriptServicePack,
  EditPanelElementModel,
  InputPartsBaseModel,
  LinkElementModel,
  PanelModel,
  PanelType,
} from '@ktvs8/gocoo-engine-front-end';

/**
 * SAP伝票番号編集ダイアログ
 */
export class SapAndInvoiceArrivalDateDialogEdit implements DevelopDialogScript {
  readonly scriptName: string = 'SapDialogEdit';

  constructor() {}

  /**
   * ダイアログが表示された際の初期処理
   * @param panelModels
   * @param service
   * @param receivedData
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack, receivedData: any): void {
    const partsList = (panelModels.get(PanelType.EditPanel) as EditPanelElementModel)
      .inputPartsList as InputPartsBaseModel[];
    const sap = partsList.find((parts) => parts.id === 'SapNumber') as InputPartsBaseModel;
    sap.value = receivedData['SapNumber'];
    const invoiceArrivalDate = partsList.find((parts) => parts.id === 'InvoiceArrivalDate') as InputPartsBaseModel;
    invoiceArrivalDate.setValue(receivedData['InvoiceArrivalDate']);
  }

  /**
   * ダイアログで何らかのボタンが押下された際の処理
   * @param panelModels パネルモデルのマップ
   * @param clickedButtonElement 押下されたボタンのモデル
   * @param service サービス
   * @returns
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ) {
    const partsList = (panelModels.get(PanelType.EditPanel) as EditPanelElementModel)
      .inputPartsList as InputPartsBaseModel[];
    const sap = partsList.find((parts) => parts.id === 'SapNumber') as InputPartsBaseModel;
    const invoiceArrivalDate = partsList.find((parts) => parts.id === 'InvoiceArrivalDate') as InputPartsBaseModel;
    let responseRecord: any = { SapNumber: sap.value, InvoiceArrivalDate: invoiceArrivalDate.value };
    if (invoiceArrivalDate.value) {
      responseRecord['InvoiceArrivald'] = true;
    } else {
      responseRecord['InvoiceArrivald'] = false;
    }

    service.dialogService.closeViewDialog(responseRecord);
    return;
  }

  /**
   * 独自のバリデーションチェック
   * @param panelModels
   * @returns
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }

  /**
   * input-partsのイベント
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ) {}

  /**
   * リンクが押下されたときの処理
   * @param panelModels パネルモデルのマップ
   * @param clickedLinkElement 押下されたリンクモデル
   * @param service スクリプトのサービス
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ) {}
}
